module.exports = __webpack_public_path__ + "img/email.29be34be.svg";